/*
 * @Author: Nanxing Xiang
 * @Date: 2021-12-23 17:14:22
 * @LastEditors: Nanxing Xiang
 * @LastEditTime: 2021-12-23 17:37:58
 * @Description: file content
 */
export const classNames = (arr: (string | undefined | false)[]) => {
  return arr.reduce((prev, curr) => {
    return curr ? `${prev} ${curr}` : prev;
  }, '') as string;
};
